/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import { AsideMenuItem } from "./components/AsideMenuItem";
import {
  faBriefcase,
  faCalendar,
  faCoins,
  faFileContract,
  faHandshake,
  faHouse,
  faCreditCardFront,
  faHammerBrush,
} from "@fortawesome/pro-light-svg-icons";
import { Menu } from "react-pro-sidebar";
import { useSelector } from "react-redux";
import { selectGlobalSettings } from "app/modules/system/settings/ClientPortalSettingsSlice";

export function AsideMenuItems() {
  const globalSettings = useSelector(selectGlobalSettings);
  return (
    <Menu
      menuItemStyles={{
        icon: {
          margin: 0,
        },
        label: {
          display: "flex",
          alignItems: "center",
          marginLeft: "10px",
        },
      }}
    >
      <AsideMenuItem title="Dashboard" to="/dashboard" icon={faHouse} data-test-id="sidebar__dashboard-link" />
      <AsideMenuItem title="Accounts" to="/accounts" icon={faCoins} data-test-id="sidebar__accounts-link" />
      {globalSettings.showJobs && (
        <AsideMenuItem title="Jobs" to="/jobs" icon={faHammerBrush} data-test-id="sidebar__jobs-link" />
      )}
      {globalSettings.showCases && (
        <AsideMenuItem title="Cases" to="/cases" icon={faBriefcase} data-test-id="sidebar__cases-link" />
      )}
      {globalSettings.showProposedWorks && (
        <AsideMenuItem
          title="Major Works"
          to="/majorworks"
          icon={faHandshake}
          data-test-id="sidebar__major-works-link"
        />
      )}
      {globalSettings.showDocuments && (
        <AsideMenuItem title="Documents" to="/documents" icon={faFileContract} data-test-id="sidebar__documents-link" />
      )}
      {globalSettings.showCreditControl && (
        <AsideMenuItem
          title="Credit Control"
          to="/CreditControl"
          icon={faCreditCardFront}
          data-test-id="sidebar__credit-control-link"
        />
      )}
      {globalSettings.showMeetings && (
        <AsideMenuItem title="Meetings" to="/meetings" icon={faCalendar} data-test-id="sidebar__meetings-link" />
      )}
    </Menu>
  );
}
